// lf-belle-widget.js — LewdFashion storefront chat widget
// Forked from OnlyLewds belle-widget.js — same look, same Belle images, LF routes.
// Upload to Shopify Assets folder
// Add to theme.liquid before </body>: <script src="{{ 'lf-belle-widget.js' | asset_url }}" defer></script>

(function () {
  'use strict';

  const BELLE_API   = 'https://belle.onlylewds.ngrok.app';

  // LF runs Shopify Markets — the storefront shows the visitor's local currency. Pass the
  // active market through so Belle quotes the SAME number the customer sees on the page,
  // instead of always quoting USD.
  // Rendered by theme.liquid inside {% if customer %} only — absent for guests.
  function customer() {
    const c = window.__belleCustomer;
    return (c && c.cid && c.sig) ? { cid: c.cid, sig: c.sig } : null;
  }

  function market() {
    try {
      return {
        country:  window.Shopify?.country  || 'US',
        currency: window.Shopify?.currency?.active || 'USD',
      };
    } catch { return { country: 'US', currency: 'USD' }; }
  }
  const GREET_URL   = BELLE_API + '/lf-storefront/greet';
  const CHAT_URL    = BELLE_API + '/lf-storefront/chat';
  const SESSION_KEY = 'lf_belle_session_id';

  // Asset URLs — uploaded to Shopify assets
  const AVATAR_URL  = window.__belleAvatarUrl  || '';
  const LOGO_URL    = window.__belleLogoUrl    || '';

  const PINK      = '#e8457a';
  const PINK_MID  = '#ff97ad';
  const PINK_LITE = '#ffb3c4';
  const WHITE     = '#ffffff';
  const DARK      = '#1a1a1a';
  const MUTED     = '#888888';
  const BG_MSG    = '#f7f7f7';

  function getSessionId() {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = 'lf-storefront-' + Math.random().toString(36).slice(2) + '-' + Date.now();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  }

  let isOpen    = false;
  let isTyping  = false;
  let greeted   = false;
  let sessionId = getSessionId();
  let msgCount  = 0;

  const css = `
    #belle-widget-btn {
      position: fixed; bottom: calc(24px + var(--lf-atc-h, 0px)); right: 24px;
      transition: bottom 0.28s cubic-bezier(0.4,0,0.2,1);
      width: 56px; height: 56px; border-radius: 50%;
      background: linear-gradient(135deg, ${PINK_MID}, ${PINK});
      border: none; cursor: pointer; z-index: 996;
      display: flex; align-items: center; justify-content: center;
      box-shadow: 0 4px 20px rgba(232,69,122,0.4);
      transition: transform 0.2s ease, box-shadow 0.2s ease;
      padding: 0; overflow: hidden;
    }
    #belle-widget-btn:hover { transform: scale(1.08); box-shadow: 0 6px 28px rgba(232,69,122,0.55); }
    /* Avatar-first launcher. A face reads "talk to a person"; the previous lock read
       "secure area / locked content", which is the wrong promise at first contact. */
    #belle-widget-btn:has(#belle-btn-img) {
      background: linear-gradient(135deg, ${PINK_MID}, ${PINK});
      border: none; padding: 3px;
    }
    #belle-btn-img { width: 100%; height: 100%; object-fit: cover;
                     border-radius: 50%; display: block; box-sizing: border-box; }
    /* Chat-bubble badge — NOT a phone glyph: she can't do voice, and a call icon
       promises something she can't deliver. */
    #belle-btn-badge {
      position: absolute; right: -2px; bottom: -2px;
      width: 24px; height: 24px; border-radius: 50%;
      background: ${PINK}; border: 2.5px solid ${WHITE};
      display: flex; align-items: center; justify-content: center;
      box-shadow: 0 1px 4px rgba(0,0,0,0.15);
    }
    #belle-btn-badge svg { width: 13px; height: 13px; display: block; }
    /* Teaser — the biggest lever on open rate, but it must never nag. Once per session. */
    #belle-teaser {
      position: fixed; right: 88px; bottom: calc(30px + var(--lf-atc-h, 0px));
      max-width: 210px; background: ${WHITE}; color: ${DARK};
      border: 1px solid ${PINK_LITE}; border-radius: 14px;
      border-bottom-right-radius: 4px; padding: 10px 32px 10px 13px;
      font-family: futura-pt, sans-serif; font-size: 13px; line-height: 1.45;
      box-shadow: 0 6px 24px rgba(232,69,122,0.18); z-index: 996; cursor: pointer;
      opacity: 0; transform: translateY(6px); pointer-events: none;
      transition: opacity .28s ease, transform .28s ease;
    }
    #belle-teaser.show { opacity: 1; transform: translateY(0); pointer-events: all; }
    #belle-teaser-x {
      position: absolute; top: 4px; right: 6px; border: none; background: none;
      color: ${MUTED}; font-size: 15px; line-height: 1; cursor: pointer; padding: 2px 4px;
      min-width: 24px; min-height: 24px; display: grid; place-items: center;
    }
    @media (max-width: 749px) { #belle-teaser { display: none; } }
    #belle-btn-fallback { width: 26px; height: 26px; }

    #belle-unread {
      position: absolute; top: -2px; right: -2px;
      width: 18px; height: 18px; border-radius: 50%;
      background: ${WHITE}; border: 2px solid ${PINK};
      display: none; align-items: center; justify-content: center;
      font-size: 10px; font-weight: 700; color: ${PINK};
      font-family: futura-pt, sans-serif;
    }

    #belle-panel {
      position: fixed; bottom: 92px; right: 24px;
      width: 360px; height: 520px;
      background: ${WHITE}; border-radius: 16px;
      box-shadow: 0 8px 48px rgba(0,0,0,0.18);
      z-index: 9997; display: flex; flex-direction: column;
      overflow: hidden; font-family: futura-pt, sans-serif;
      transform: translateY(16px) scale(0.97); opacity: 0;
      pointer-events: none;
      transition: transform 0.25s cubic-bezier(0.34,1.56,0.64,1), opacity 0.2s ease;
    }
    #belle-panel.open { transform: translateY(0) scale(1); opacity: 1; pointer-events: all; }

    #belle-header {
      background: linear-gradient(135deg, ${PINK_MID} 0%, ${PINK} 100%);
      padding: 14px 16px 12px;
      display: flex; align-items: center; justify-content: space-between;
      flex-shrink: 0;
    }
    .belle-header-info { display: flex; align-items: center; gap: 10px; }
    .belle-avatar {
      width: 38px; height: 38px; border-radius: 50%;
      border: 2px solid rgba(255,255,255,0.5);
      overflow: hidden; flex-shrink: 0;
      background: rgba(255,255,255,0.2);
      display: flex; align-items: center; justify-content: center;
      font-size: 18px;
    }
    .belle-avatar img { width: 100%; height: 100%; object-fit: cover; display: block; }
    .belle-header-name { color: ${WHITE}; font-size: 15px; font-weight: 600; letter-spacing: 0.03em; line-height: 1.2; }
    .belle-header-sub { color: rgba(255,255,255,0.75); font-size: 11px; letter-spacing: 0.06em; text-transform: uppercase; margin-top: 1px; }
    #belle-close {
      background: none; border: none; cursor: pointer;
      color: rgba(255,255,255,0.8); padding: 4px;
      display: flex; align-items: center; transition: color 0.15s;
    }
    #belle-close:hover { color: ${WHITE}; }
    #belle-close svg { width: 18px; height: 18px; }

    #belle-messages {
      flex: 1; overflow-y: auto; padding: 16px 14px;
      display: flex; flex-direction: column; gap: 10px;
      scroll-behavior: smooth;
    }
    #belle-messages::-webkit-scrollbar { width: 3px; }
    #belle-messages::-webkit-scrollbar-thumb { background: ${PINK_LITE}; border-radius: 2px; }

    .belle-msg { display: flex; gap: 8px; animation: belleFadeIn 0.2s ease; }
    .belle-msg.user { flex-direction: row-reverse; }
    @keyframes belleFadeIn {
      from { opacity: 0; transform: translateY(6px); }
      to   { opacity: 1; transform: translateY(0); }
    }

    .belle-bubble {
      max-width: 80%; padding: 9px 13px; border-radius: 14px;
      font-size: 13.5px; line-height: 1.55; word-break: break-word;
    }
    .belle-msg.belle .belle-bubble { background: ${BG_MSG}; color: ${DARK}; border-bottom-left-radius: 4px; }
    .belle-msg.user  .belle-bubble { background: linear-gradient(135deg, ${PINK_MID}, ${PINK}); color: ${WHITE}; border-bottom-right-radius: 4px; }
    .belle-bubble a { color: ${PINK}; text-decoration: underline; text-underline-offset: 2px; }
    .belle-msg.user .belle-bubble a { color: rgba(255,255,255,0.9); }
    .belle-bubble strong { font-weight: 600; }

    .belle-product-link {
      display: flex; align-items: center; gap: 8px;
      background: ${WHITE}; border: 1px solid #f0f0f0;
      border-radius: 8px; padding: 8px 10px; margin-top: 6px;
      text-decoration: none !important; transition: border-color 0.15s;
    }
    .belle-product-link:hover { border-color: ${PINK_LITE}; }
    .belle-product-link span { font-size: 12.5px; color: ${DARK}; font-weight: 500; flex: 1; }
    .belle-product-link .arrow { color: ${PINK}; font-size: 14px; }

    /* Product cards. Rendered from the STRUCTURED products array the API already
       returns — not parsed out of the model's prose the way OnlyLewds does it, so a
       reworded reply can never break the cards. Images load from Shopify's CDN in the
       browser; the model never sees them, so they cost zero tokens. */
    .belle-cards { display: flex; flex-direction: column; gap: 6px; margin: 2px 0 2px 0; }
    .belle-card {
      display: flex; align-items: center; gap: 10px;
      background: ${WHITE}; border: 1px solid #f3e3e9;
      border-radius: 12px; padding: 7px 10px 7px 7px;
      text-decoration: none !important;
      transition: border-color .15s ease, transform .15s ease, box-shadow .15s ease;
      animation: belleFadeIn .22s ease;
    }
    .belle-card:hover {
      border-color: ${PINK_MID}; transform: translateY(-1px);
      box-shadow: 0 4px 14px rgba(232,69,122,0.13);
    }
    .belle-card img {
      width: 46px; height: 46px; object-fit: cover; border-radius: 9px;
      flex-shrink: 0; background: ${BG_MSG};
    }
    .belle-card .c-info { flex: 1; min-width: 0; }
    .belle-card .c-title {
      font-size: 12.5px; font-weight: 600; color: ${DARK}; line-height: 1.3;
      white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
    }
    .belle-card .c-price { font-size: 12px; color: ${PINK}; font-weight: 600; margin-top: 2px; }
    .belle-card .c-sold  { font-size: 10.5px; color: ${MUTED}; margin-left: 5px; font-weight: 500; }
    .belle-card .c-arrow { color: ${PINK}; font-size: 15px; flex-shrink: 0; }

    #belle-typing { display: none; padding: 0 14px 8px; }
    #belle-typing.show { display: flex; gap: 8px; align-items: center; }
    .belle-typing-dots {
      background: ${BG_MSG}; padding: 9px 14px; border-radius: 14px;
      border-bottom-left-radius: 4px; display: flex; gap: 4px; align-items: center;
    }
    .belle-typing-dots span {
      width: 5px; height: 5px; border-radius: 50%; background: ${MUTED};
      animation: belleDot 1.2s infinite;
    }
    .belle-typing-dots span:nth-child(2) { animation-delay: 0.2s; }
    .belle-typing-dots span:nth-child(3) { animation-delay: 0.4s; }
    @keyframes belleDot {
      0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
      30%            { transform: translateY(-4px); opacity: 1; }
    }

    #belle-quick-replies {
      padding: 4px 14px 8px; display: flex;
      gap: 6px; flex-wrap: wrap; flex-shrink: 0;
    }
    .belle-qr {
      background: none; border: 1px solid ${PINK_LITE}; color: ${PINK};
      padding: 5px 11px; border-radius: 20px; font-size: 12px;
      font-family: futura-pt, sans-serif; cursor: pointer;
      white-space: nowrap; transition: all 0.15s; letter-spacing: 0.02em;
    }
    .belle-qr:hover { background: ${PINK}; color: ${WHITE}; border-color: ${PINK}; }

    #belle-input-area {
      border-top: 1px solid #f0f0f0; padding: 10px 12px;
      display: flex; gap: 8px; align-items: flex-end;
      flex-shrink: 0; background: ${WHITE};
    }
    #belle-input {
      flex: 1; border: 1px solid #e8e8e8; border-radius: 22px;
      padding: 9px 14px; font-size: 13.5px; font-family: futura-pt, sans-serif;
      color: ${DARK}; resize: none; outline: none;
      max-height: 80px; min-height: 38px; line-height: 1.4;
      transition: border-color 0.15s; background: ${WHITE};
    }
    #belle-input:focus { border-color: ${PINK_MID}; }
    #belle-input::placeholder { color: ${MUTED}; }
    #belle-send {
      width: 36px; height: 36px; border-radius: 50%;
      background: linear-gradient(135deg, ${PINK_MID}, ${PINK});
      border: none; cursor: pointer;
      display: flex; align-items: center; justify-content: center;
      flex-shrink: 0; transition: transform 0.15s, opacity 0.15s; opacity: 0.5;
    }
    #belle-send.ready { opacity: 1; }
    #belle-send:hover.ready { transform: scale(1.08); }
    #belle-send svg { width: 16px; height: 16px; }

    /* Product thumbnail cards */
    .belle-product-card {
      display: flex; align-items: center; gap: 10px;
      background: white; border: 1px solid #f0f0f0;
      border-radius: 10px; padding: 8px 10px; margin-top: 6px;
      text-decoration: none !important; transition: border-color 0.15s;
      overflow: hidden;
    }
    .belle-product-card:hover { border-color: #ffb3c4; }
    .belle-product-card img {
      width: 48px; height: 48px; object-fit: cover;
      border-radius: 6px; flex-shrink: 0; background: #f7f7f7;
    }
    .belle-product-card .card-info { flex: 1; min-width: 0; }
    .belle-product-card .card-title {
      font-size: 12.5px; font-weight: 600; color: #1a1a1a;
      white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
      line-height: 1.3;
    }
    .belle-product-card .card-price {
      font-size: 11.5px; color: #888; margin-top: 2px;
    }
    .belle-product-card .card-arrow {
      color: #e8457a; font-size: 16px; flex-shrink: 0; font-weight: 300;
    }

    #belle-footer {
      text-align: center; padding: 4px 0 6px;
      font-size: 10px; color: #ccc; letter-spacing: 0.05em;
      text-transform: uppercase; flex-shrink: 0;
    }

    @media (max-width: 480px) {
      #belle-widget-btn {
        bottom: 16px;
        right: 16px;
        width: 52px;
        height: 52px;
      }
      #belle-panel {
        /* Full width with safe margins, no overflow */
        width: 100vw;
        right: 0;
        left: 0;
        bottom: 0;
        border-radius: 20px 20px 0 0;
        /* Use dynamic viewport height to account for keyboard */
        height: 65dvh;
        min-height: 380px;
        max-height: 85dvh;
        /* Prevent content from going under home indicator */
        padding-bottom: env(safe-area-inset-bottom, 0px);
      }
      #belle-header {
        border-radius: 20px 20px 0 0;
        padding: 16px 16px 12px;
      }
      #belle-messages {
        /* Ensure messages area scrolls properly on mobile */
        -webkit-overflow-scrolling: touch;
        overscroll-behavior: contain;
      }
      #belle-input-area {
        /* Stick to bottom, above home indicator */
        padding: 8px 12px;
        padding-bottom: max(8px, env(safe-area-inset-bottom));
      }
      #belle-input {
        font-size: 16px; /* Prevents iOS zoom on focus */
      }
      #belle-quick-replies {
        padding: 4px 12px 6px;
        gap: 5px;
      }
      .belle-qr {
        font-size: 11px;
        padding: 5px 10px;
      }
      #belle-footer {
        padding: 3px 0 4px;
        font-size: 9px;
      }
      /* Wider bubbles on mobile */
      .belle-bubble { max-width: 88%; }
    }
  `;

  const styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  // Build avatar HTML — use photo if available, fallback to emoji
  const avatarHtml = AVATAR_URL
    ? `<img src="${AVATAR_URL}" alt="Belle" />`
    : '💖';

  // Build button inner — branded LF lock PNG if provided, else the inline SVG lock.
  const btnFallbackSvg = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="26" height="26">
    <rect x="5" y="11" width="14" height="10" rx="2" fill="white" fill-opacity="0.95"/>
    <path d="M8 11V7C8 4.79 9.79 3 12 3C14.21 3 16 4.79 16 7V11" stroke="white" stroke-width="2.2" stroke-linecap="round" fill="none"/>
    <circle cx="12" cy="16" r="1.5" fill="${PINK}"/>
  </svg>`;

  // Prefer Belle's face over the logo mark — see the CSS note above.
  const launcherImg = AVATAR_URL || LOGO_URL;
  const btnInnerHtml = launcherImg
    ? `<img id="belle-btn-img" src="${launcherImg}" alt="Chat with Belle" />
       <div id="belle-btn-badge" aria-hidden="true">
         <svg viewBox="0 0 24 24" fill="${WHITE}"><path d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"/></svg>
       </div>`
    : btnFallbackSvg;

  const wrapper = document.createElement('div');
  wrapper.id = 'belle-widget-root';
  wrapper.innerHTML = `
    <div id="belle-teaser" role="button" tabindex="0">
      <button id="belle-teaser-x" aria-label="Dismiss">&times;</button>
      Need a hand with sizing or a lewk? I'm right here 💕
    </div>

    <button id="belle-widget-btn" aria-label="Chat with Belle">
      ${btnInnerHtml}
      <div id="belle-unread">1</div>
    </button>

    <div id="belle-panel" role="dialog" aria-label="Chat with Belle">
      <div id="belle-header">
        <div class="belle-header-info">
          <div class="belle-avatar">${avatarHtml}</div>
          <div>
            <div class="belle-header-name">Belle</div>
            <div class="belle-header-sub">Lewd Fashion · Online</div>
          </div>
        </div>
        <button id="belle-close" aria-label="Close chat">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>

      <div id="belle-messages"></div>
      <div id="belle-typing"><div class="belle-typing-dots"><span></span><span></span><span></span></div></div>
      <div id="belle-quick-replies"></div>

      <div id="belle-input-area">
        <textarea id="belle-input" rows="1" placeholder="Message Belle…" maxlength="500"></textarea>
        <button id="belle-send" aria-label="Send">
          <svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round">
            <line x1="22" y1="2" x2="11" y2="13"/>
            <polygon points="22 2 15 22 11 13 2 9 22 2" fill="white" stroke="none"/>
          </svg>
        </button>
      </div>
      <div id="belle-footer">Lewd Fashion ✦ Belle</div>
    </div>
  `;
  document.body.appendChild(wrapper);

  const btn      = document.getElementById('belle-widget-btn');
  const panel    = document.getElementById('belle-panel');
  const closeBtn = document.getElementById('belle-close');
  const messages = document.getElementById('belle-messages');
  const typing   = document.getElementById('belle-typing');
  const qrArea   = document.getElementById('belle-quick-replies');
  const teaser   = document.getElementById('belle-teaser');

  // Teaser: show once per browser session, 7s in, only if they haven't opened chat.
  // Dismissing sticks for the session — a nag that reappears is worse than no teaser.
  const TEASER_KEY = 'lf_belle_teaser_seen';
  function hideTeaser(remember) {
    if (!teaser) return;
    teaser.classList.remove('show');
    if (remember) { try { sessionStorage.setItem(TEASER_KEY, '1'); } catch (_) {} }
  }
  if (teaser && !sessionStorage.getItem(TEASER_KEY)) {
    setTimeout(() => { if (!isOpen) teaser.classList.add('show'); }, 7000);
    teaser.addEventListener('click', (e) => {
      if (e.target.id === 'belle-teaser-x') { e.stopPropagation(); hideTeaser(true); return; }
      hideTeaser(true); btn.click();
    });
    teaser.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); hideTeaser(true); btn.click(); }
    });
  }
  const input    = document.getElementById('belle-input');
  const sendBtn  = document.getElementById('belle-send');
  const unread   = document.getElementById('belle-unread');

  const INITIAL_QR = ["What's new?", "Show me collections", "Size & fit", "Shipping & returns"];

  // ── QUICK REPLY ROUTING ───────────────────────────────────────────────────────
  // Maps display text to the actual message sent — so "What's new?" sends
  // "show me new releases" which hits the new_releases intent correctly
  const QR_MAP = {
    "What's new?":         "show me new releases",
    "Best sellers":        "show me best sellers",
    "Show me collections": "show me your collections",
    "Track my order":      "I want to track my order",
    "Size & fit":          "do these run true to size",
    "Shipping & returns":  "what is your shipping and return policy",
    "Tell me more":        "tell me more",
    "Show me something else": "show me something else",
  };

  function showQuickReplies(replies) {
    qrArea.innerHTML = '';
    replies.forEach(label => {
      const b = document.createElement('button');
      b.className = 'belle-qr';
      b.textContent = label;
      b.onclick = () => {
        qrArea.innerHTML = '';
        const msg = QR_MAP[label] || label;
        sendMessage(msg, label); // send mapped msg, display original label
      };
      qrArea.appendChild(b);
    });
  }

  // ── OPEN / CLOSE ─────────────────────────────────────────────────────────────
  function openWidget() {
    isOpen = true;
    panel.classList.add('open');
    unread.style.display = 'none';
    btn.setAttribute('aria-expanded', 'true');
    if (!greeted) { greeted = true; fetchGreeting(); }
    setTimeout(() => input.focus(), 300);
  }

  function closeWidget() {
    isOpen = false;
    panel.classList.remove('open');
    btn.setAttribute('aria-expanded', 'false');
  }

  btn.addEventListener('click', (e) => {
    hideTeaser(true);
    e.stopPropagation();
    isOpen ? closeWidget() : openWidget();
  });

  closeBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    closeWidget();
  });

  // FIX: only close on outside click when NOT waiting for a response
  document.addEventListener('click', e => {
    if (!isOpen) return;
    if (isTyping) return; // ← don't close while Belle is replying
    if (panel.contains(e.target) || btn.contains(e.target)) return;
    closeWidget();
  });

  // Max 3 cards — enough to choose from without burying the conversation.
  function appendCards(products) {
    if (!Array.isArray(products) || !products.length) return;
    const wrap = document.createElement('div');
    wrap.className = 'belle-cards';
    wrap.innerHTML = products.slice(0, 3).map(p => {
      const img = p.image
        ? `<img src="${p.image}" alt="" loading="lazy" onerror="this.style.visibility='hidden'">`
        : `<img alt="" style="visibility:hidden">`;
      const sold = p.available === false ? '<span class="c-sold">sold out</span>' : '';
      const price = p.price ? `$${p.price}` : '';
      return `<a class="belle-card" href="${p.url}" target="_blank" rel="noopener">
        ${img}
        <div class="c-info">
          <div class="c-title">${String(p.title).replace(/[<>]/g, '')}</div>
          <div class="c-price">${price}${sold}</div>
        </div>
        <span class="c-arrow">›</span>
      </a>`;
    }).join('');
    messages.appendChild(wrap);
    messages.scrollTop = messages.scrollHeight;
  }

  // ── GREETING ─────────────────────────────────────────────────────────────────
  async function fetchGreeting() {
    showTyping(true);
    try {
      const r    = await fetch(GREET_URL);
      const data = await r.json();
      showTyping(false);
      appendMessage('belle', data.response);
      showQuickReplies(INITIAL_QR);
    } catch {
      showTyping(false);
      appendMessage('belle', "Hiii gorgeous 😘 I'm Belle — what are we putting you in today?");
      showQuickReplies(INITIAL_QR);
    }
  }

  // ── SEND MESSAGE ──────────────────────────────────────────────────────────────
  // displayText = what shows in chat bubble (optional, falls back to text)
  async function sendMessage(text, displayText) {
    if (!text.trim() || isTyping) return;
    qrArea.innerHTML = '';
    appendMessage('user', displayText || text);
    input.value = '';
    input.style.height = 'auto';
    sendBtn.classList.remove('ready');
    isTyping = true;
    msgCount++;

    showTyping(true);
    try {
      const r = await fetch(CHAT_URL, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ message: text, sessionId, ...market(), customer: customer() }),
      });
      const data = await r.json();
      showTyping(false);
      isTyping = false;
      appendMessage('belle', data.response);
      appendCards(data.products);

      if (msgCount === 1) {
        showQuickReplies(["Tell me more", "Show me something else"]);
      }
    } catch {
      showTyping(false);
      isTyping = false;
      appendMessage('belle', "Hmm, something went wrong 😅 Try again in a sec?");
    }
  }

  // ── APPEND MESSAGE ────────────────────────────────────────────────────────────
  function appendMessage(who, text) {
    const div    = document.createElement('div');
    div.className = 'belle-msg ' + who;
    const bubble  = document.createElement('div');
    bubble.className = 'belle-bubble';
    bubble.innerHTML = formatMessage(text);
    div.appendChild(bubble);
    messages.appendChild(div);
    messages.scrollTop = messages.scrollHeight;
    if (!isOpen && who === 'belle') {
      unread.style.display = 'flex';
    }
  }

  // ── FORMAT MESSAGE ────────────────────────────────────────────────────────────
  // Handles PRODUCT|title|url|price|imageUrl pipe format from backend
  function formatMessage(text) {
    const lines = text.split('\n');
    let html = '';
    for (const line of lines) {
      if (line.startsWith('PRODUCT|')) {
        const parts = line.split('|');
        const title    = parts[1] || '';
        const url      = parts[2] || '#';
        const price    = parts[3] || '';
        const imageUrl = parts[4] || '';
        const imgHtml  = imageUrl
          ? `<img src="${imageUrl}" alt="${title}" loading="lazy" />`
          : `<div style="width:48px;height:48px;border-radius:6px;background:#f7f7f7;flex-shrink:0"></div>`;
        html += `<a class="belle-product-card" href="${url}" target="_blank">
          ${imgHtml}
          <div class="card-info">
            <div class="card-title">${title}</div>
            ${price ? `<div class="card-price">${price}</div>` : ''}
          </div>
          <span class="card-arrow">›</span>
        </a>`;
      } else {
        // Regular text line — apply markdown formatting
        let formatted = line
          .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
          .replace(/\[(.*?)\]\((https?:\/\/lewdfashion\.com[^)]*)\)/g, (_, label, url) =>
            `<a class="belle-product-link" href="${url}" target="_blank"><span>${label}</span><span class="arrow">→</span></a>`)
          .replace(/\[(.*?)\]\((https?:\/\/[^)]*)\)/g, '<a href="$2" target="_blank">$1</a>');
        if (formatted.trim()) html += `<div>${formatted}</div>`;
      }
    }
    return html;
  }

  // ── TYPING ────────────────────────────────────────────────────────────────────
  function showTyping(show) {
    typing.classList.toggle('show', show);
    if (show) messages.scrollTop = messages.scrollHeight;
  }

  // ── INPUT ─────────────────────────────────────────────────────────────────────
  input.addEventListener('input', () => {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 80) + 'px';
    sendBtn.classList.toggle('ready', input.value.trim().length > 0);
  });

  input.addEventListener('keydown', e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (input.value.trim()) sendMessage(input.value.trim());
    }
  });

  sendBtn.addEventListener('click', () => {
    if (input.value.trim()) sendMessage(input.value.trim());
  });

  // Pulse unread badge after 8s if not opened
  setTimeout(() => {
    if (!isOpen && !greeted) unread.style.display = 'flex';
  }, 8000);

})();
